// extracted by mini-css-extract-plugin
module.exports = {"AboundPopupwrapper":"fs0f9","heading":"Bo85t","AboundInfoCard":"dTL6Z","AboundInfoText":"C7bg2","highlight":"SYKXu","consentCTA":"njCSa"};